export default "__VITE_ASSET__RhVCI46E__"